import { render, staticRenderFns } from "./GetCode.vue?vue&type=template&id=71d773e5&scoped=true&"
import script from "./GetCode.vue?vue&type=script&lang=js&"
export * from "./GetCode.vue?vue&type=script&lang=js&"
import style0 from "./GetCode.vue?vue&type=style&index=0&id=71d773e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d773e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
